
import React from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Footer from "./components/common/footer/Footer";
import Header from "./components/common/heading/Header";
import Home from "./components/home/hero/Home";
import InfoPage from "./components/pages/InfoPage";
import NewsDetail from "./components/pages/NewsDetail";
import { PortalAccessProvider } from "./components/portal/PortalAccessProvider";
import { SITE_PAGES } from "./data/sitePages";
import { getPortalLink } from "./utils/portalLinks";

const sitePages = SITE_PAGES.filter((page) => page.path !== "/admissions/apply");


function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
}

function ApplicantPortalRedirect() {
  useEffect(() => {
    window.location.replace(getPortalLink("applicant"));
  }, []);

  return (
    <main className="min-h-[45vh] bg-[#fffdfa] px-6 py-20 text-center text-[#102046]">
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8a6a33]">
        S-TEE Admissions
      </p>
      <h1 className="mt-4 text-4xl">Opening applicant access...</h1>
    </main>
  );
}

function App() {
  const location = useLocation();

  return (
    <PortalAccessProvider>
      <div className="app-shell">
        {/* VerticalScrollIndicator removed */}
        <ScrollToTopOnRouteChange />
        <Header />
        <main key={location.pathname} className="app-route-stage">
          <Routes>
            <Route index element={<Home />} />
            {/* News detail route: /news/:slug */}
            <Route path="news/:slug" element={<NewsDetail />} />
            <Route path="admissions/apply" element={<ApplicantPortalRedirect />} />
            {sitePages.map((page) => (
              <Route
                key={page.path}
                path={page.path.slice(1)}
                element={<InfoPage {...page} />}
              />
            ))}
            <Route path="explore" element={require("./components/pages/Explore").default ? React.createElement(require("./components/pages/Explore").default) : null} />
          </Routes>
        </main>
        <Footer />
      </div>
    </PortalAccessProvider>
  );
}

export default App;
